"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const avatar_1 = __importDefault(require("./avatar/avatar"));
const areas_1 = __importDefault(require("./areas/areas"));
require("./expertView.scss");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const common_1 = require("../../../../utils/common");
const ExpertView = (props) => {
    const stateDefiner = (states) => states.length === 1 ? states[0].name : states.length === 51 ? 'Nationwide' : 'Multiple Locations';
    const { expertList, directoryType, filters: { limit } } = props;
    const _target = !common_1.ifMobile() ? '_blank' : '_self';
    const getUrl = (uid) => {
        return `#/directory/${directoryType == 'experts'
            ? 'expertsProfile'
            : 'servicesProfile'}?uid=${uid}`;
    };
    const experts = expertList === null || expertList === void 0 ? void 0 : expertList.map((expert, key) => {
        var _a;
        return react_1.default.createElement("div", { key: expert.expert_id },
            react_1.default.createElement("div", { className: "expert-view" },
                react_1.default.createElement("div", { className: "expert-view-info" },
                    react_1.default.createElement(avatar_1.default, { uid: expert.uid, imageUrl: expert.avatar, name: expert.name, directoryType: directoryType }),
                    react_1.default.createElement("div", { className: "expert-name" },
                        react_1.default.createElement("div", { className: "exp-info" },
                            expert.expert_name && react_1.default.createElement("div", { className: "exp-nm" },
                                react_1.default.createElement("a", { target: _target, href: getUrl(expert.uid) }, expert.expert_name)),
                            expert.company_name && react_1.default.createElement("div", { className: "exp-cp" },
                                expert.is_company &&
                                    react_1.default.createElement("a", { target: _target, href: getUrl(expert.uid) }, expert.company_name),
                                !expert.is_company && expert.company_name),
                            react_1.default.createElement("div", { className: "exp-occup" }, expert.type === 0 ? expert.blocks.occupation : (_a = expert.mainService) === null || _a === void 0 ? void 0 : _a.name),
                            react_1.default.createElement("div", null, stateDefiner(expert.states))),
                        react_1.default.createElement("div", { className: "exp-link" },
                            react_1.default.createElement("a", { href: getUrl(expert.uid), target: _target, className: "v2-btn v2-btn-primary" }, "View Profile")))),
                react_1.default.createElement("div", { className: `expert-view-bio ${!expert.areas.length && expert.bio ? 'mb-20 mb-md-15' : ''}` }, expert.bio),
                expert.areas.length ? react_1.default.createElement(areas_1.default, { props: Object.assign({}, props), areasList: expert.areas, expertId: expert.uid }) : null,
                react_1.default.createElement("div", { className: "exp-link-mb" },
                    react_1.default.createElement("a", { href: getUrl(expert.uid), target: _target, className: "v2-btn v2-btn-primary" }, "View Profile"))),
            key < (limit - 1) && react_1.default.createElement("div", { className: "block-separator" }));
    });
    return (react_1.default.createElement(react_1.Fragment, null, experts));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        filters: experts.filter
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getExperts: (data) => dispatch(expertsSlice_1.getExperts(data)),
        getServiceExperts: (data) => dispatch(expertsSlice_1.getServiceExperts(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpertView);
